import { ImportTripsErrorCodes } from '../enums';

export interface IBulkTripsErrorType {
    message: string;
    entity: 'trip' | 'order';
    operation: 'create' | 'update';
    code?: string;
    errorCode?: ImportTripsErrorCodes;
    index?: number;
}
